import React from "react";
import { getContactHref } from "../../../utils";
import styles from "./Author.module.scss";
import { useSiteMetadata } from "../../../hooks";

const Author = () => {
  const { author } = useSiteMetadata();

  return (
    <div
      className={styles["author"]}
      // @ts-ignore
      itemProp="author"
      itemScope
      itemType="http://schema.org/Person"
    >
      <p className={styles["author__bio"]}>
        {/* @ts-ignore */}
        <span itemProp="description">{author.bio}</span>
        <a
          className={styles["author__bio-twitter"]}
          href={getContactHref("twitter", author.contacts.twitter)}
          rel="noopener noreferrer"
          target="_blank"
        >
          {/* @ts-ignore */}
          <strong itemProp="name">{author.name}</strong> on Twitter
        </a>
      </p>
    </div>
  );
};

export default Author;
